import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=2efb3067&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=2efb3067&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb3067",
  null
  
)

export default component.exports